// extracted by mini-css-extract-plugin
export default {"wrapper":"View_wrapper__60ZRo","container":"View_container__drjXD","content":"View_content__CHJw3"};